export default __webpack_public_path__ + "static/media/logo-progress.8ce2e41d.png";